import OrganisationUI from "../PureComponents/OrganisationUI";
import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const RenderOrganisation = () => {
  const params = useParams();
  const location = useLocation();

  const general_info = useSelector((state) => state.renderGeneralInfo);
  const role = useSelector((state) => state.authenticationReducer?.role);
  const orgInfo = useSelector((state) => state.renderOrganizationInfoReducer) || {};

  // Extract IDs
  const selfOrgId = general_info?.org_id?.toString();
  const paramOrgId = params?.org_id?.toString();
  const stateOrgId = location.state?.data?.toString();

  // Priority: state → params → self
  const targetOrgId = stateOrgId || paramOrgId || selfOrgId;

  // Super Admin check (-1 means all orgs)
  const isSuperAdmin = selfOrgId === "-1";

  // Self org rules:
  // 1. Super admin = self
  // 2. direct match
  // 3. force self when coming via navigation state
  const ourOrg =
    isSuperAdmin ||
    targetOrgId === selfOrgId ||
    location.state?.from === "navigation";
  return (
    <OrganisationUI
      general_info={ourOrg ? general_info : orgInfo}
      role={ourOrg ? role : "other"}
    />
  );
};

export default RenderOrganisation;

// import OrganisationUI from "../PureComponents/OrganisationUI";
// import React from "react";
// import { useParams } from "react-router-dom";
// import { useSelector } from "react-redux";

// const RenderOrganisation = () => {
//   let data = useParams();

//   // organization details depends wherther our org or other org
//   const general_info = useSelector((state) => state.renderGeneralInfo);
//   const role = useSelector((state) => state.authenticationReducer?.role);
//   let organization_info = useSelector(
//     (state) => state.renderOrganizationInfoReducer
//   );
//   let ourOrg = true;

//   if (
//     organization_info === undefined ||
//     organization_info === null ||
//     organization_info === "" ||
//     organization_info?.length === 0
//   ) {
//     organization_info = {};
//   }

//   if (Object.keys(organization_info).length !== 0) {
//     if (general_info?.id?.toString() !== data?.org_id?.toString()) {
//       ourOrg = false;
//     }
//   }

//   return (
//     <>
//       <OrganisationUI
//         general_info={
//           ourOrg && Object.keys(organization_info).length?.toString() === "0"
//             ? general_info
//             : organization_info
//         }
//         role={
//           ourOrg && Object.keys(organization_info).length?.toString() === "0"
//             ? role
//             : "other"
//         }
//       />
//     </>
//   );
// };

// export default RenderOrganisation;
